import { useCallback, useState } from "react";
import { toast } from "react-hot-toast";
import api from "../../../utils/api";
import "./mail.css";

const Mail = ({ open, close, btn = "Send", app = false }) => {
  const [mail, setMail] = useState("");
  const [file, setFile] = useState();
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUpload = (e) => {
    setFile(e.target.files[0]);
  };

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  }, []);

  const send = async () => {
    if (!mail.trim()) {
      toast.error("Please enter a message.");
      return;
    }

    setLoading(true);

    try {
      // const formData = new FormData();
      // formData.append("msg", mail);
      // if (file) formData.append("file", file);

      const data = {
        msg: mail,
      }
      
      const endpoint = app
        ? `/applications/send/${open}`
        : `/students/send/${open}`;

      await api.post(endpoint, data, {
        withCredentials: true,
      });

      toast.success("Mail sent successfully!");
      setMail("");
      setFile(null);
      setIsDragging(false);
      close();
    } catch (err) {
      console.error(err);
      toast.error("Failed to send mail.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="delete-card-overlay">
    <div className="mail-card">
      <textarea
        name=""
        id=""
        rows="6"
        placeholder="Write your mail here"
        value={mail}
        onChange={(e) => setMail(e.target.value)}
        style={{
          resize: "none",
          width: "100%",
          border: "1px solid #ccc",
          borderRadius: "5px",
          padding: "10px",
        }}
      ></textarea>
      {/* <h5 style={{ marginTop: "20px", marginBottom: "5px" }}>Attachment :</h5>
      <div
        className={`drop-zone ${isDragging ? "dragging" : ""}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          marginTop: "20px",
          padding: "30px",
          border: "2px dashed #aaa",
          borderRadius: "6px",
          textAlign: "center",
        }}
      >
        <input
          type="file"
          name="file"
          onChange={handleUpload}
          id="file-input"
          className="file-input"
          style={{ display: "none" }}
        />
        <label htmlFor="file-input" className="file-label" style={{ cursor: "pointer" }}>
          {file ? (
            <div className="file-info">
              <span className="file-name">{file.name}</span>
              <span className="file-size">
                ({(file.size / 1024).toFixed(2)} KB)
              </span>
            </div>
          ) : (
            <div className="upload-placeholder">
              <p>📁 Drag & drop your file here or click to browse</p>
            </div>
          )}
        </label>
      </div> */}
      <div className="action-box">
        <button onClick={send}>{btn}</button>
        <button onClick={close}>No</button>
      </div>
    </div>
    </div>
  );
};

export default Mail;
